import {
  GET_COUNTRIES,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_FAILURE,
  GET_ONLINE_USERS,
  GET_ONLINE_USERS_SUCCESS,
  GET_ONLINE_USERS_FAILURE,
  GET_PROGRAM_TYPES,
  GET_PROGRAM_TYPES_SUCCESS,
  GET_PROGRAM_TYPES_FAILURE,
  GET_PROGRAMS,
  GET_PROGRAMS_SUCCESS,
  GET_PROGRAMS_FAILURE,
  GET_POPULAR_SUBS,
  GET_POPULAR_SUBS_SUCCESS,
  GET_POPULAR_SUBS_FAILURE,
  GET_VISA_INFO,
  GET_VISA_INFO_SUCCESS,
  GET_VISA_INFO_FAILURE,
  ADD_VISA_INFO,
  ADD_VISA_INFO_SUCCESS,
  ADD_VISA_INFO_FAILURE,
  EDIT_VISA_INFO,
  EDIT_VISA_INFO_SUCCESS,
  EDIT_VISA_INFO_FAILURE,
  DELETE_VISA_INFO,
  DELETE_VISA_INFO_SUCCESS,
  DELETE_VISA_INFO_FAILURE,
  UPLOAD_IMAGE,
  UPLOAD_IMAGE_SUCCESS,
  UPLOAD_IMAGE_FAILURE,
  UPLOAD_FILE,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAILURE,
  GET_PAYMENT_PLANS,
  GET_PAYMENT_PLANS_SUCCESS,
  GET_PAYMENT_PLANS_FAILURE,
  GET_TAGS,
  GET_TAGS_SUCCESS,
  GET_TAGS_FAILURE,
  GET_DIFF_UNI_VALUES,
  GET_DIFF_UNI_VALUES_SUCCESS,
  GET_DIFF_UNI_VALUES_FAILURE,
  ADD_COUNTRY,
  ADD_COUNTRY_SUCCESS,
  ADD_COUNTRY_FAILURE,
  GET_CONTINENTS,
  GET_CONTINENTS_SUCCESS,
  GET_CONTINENTS_FAILURE,
  GET_REGIONS,
  GET_REGIONS_SUCCESS,
  GET_REGIONS_FAILURE,
  EDIT_COUNTRY,
  EDIT_COUNTRY_SUCCESS,
  EDIT_COUNTRY_FAILURE,
} from "../constants";

export default class OthersAction {
  static getCountries(cb) {
    return {
      type: GET_COUNTRIES,
      cb,
    };
  }
  static getCountriesSuccess(payload) {
    return {
      type: GET_COUNTRIES_SUCCESS,
      payload,
    };
  }
  static getCountriesFailure(payload) {
    return {
      type: GET_COUNTRIES_FAILURE,
      payload,
    };
  }
  static addCountry(payload, cb) {
    return {
      type: ADD_COUNTRY,
      payload,
      cb,
    };
  }
  static addCountrySuccess(payload) {
    return {
      type: ADD_COUNTRY_SUCCESS,
      payload,
    };
  }
  static addCountryFailure(payload) {
    return {
      type: ADD_COUNTRY_FAILURE,
      payload,
    };
  }
  static editCountry(payload, cb) {
    return {
      type: EDIT_COUNTRY,
      payload,
      cb,
    };
  }
  static editCountrySuccess(payload) {
    return {
      type: EDIT_COUNTRY_SUCCESS,
      payload,
    };
  }
  static editCountryFailure(payload) {
    return {
      type: EDIT_COUNTRY_FAILURE,
      payload,
    };
  }
  static getContinents(cb) {
    return {
      type: GET_CONTINENTS,
      cb,
    };
  }
  static getContinentsSuccess(payload) {
    return {
      type: GET_CONTINENTS_SUCCESS,
      payload,
    };
  }
  static getContinentsFailure(payload) {
    return {
      type: GET_CONTINENTS_FAILURE,
      payload,
    };
  }
  static getRegions(cb) {
    return {
      type: GET_REGIONS,
      cb,
    };
  }
  static getRegionsSuccess(payload) {
    return {
      type: GET_REGIONS_SUCCESS,
      payload,
    };
  }
  static getRegionsFailure(payload) {
    return {
      type: GET_REGIONS_FAILURE,
      payload,
    };
  }
  static getPopularSubs(cb) {
    return {
      type: GET_POPULAR_SUBS,
      cb,
    };
  }
  static getPopularSubsSuccess(payload) {
    return {
      type: GET_POPULAR_SUBS_SUCCESS,
      payload,
    };
  }
  static getPopularSubsFailure(payload) {
    return {
      type: GET_POPULAR_SUBS_FAILURE,
      payload,
    };
  }
  static getTags(cb) {
    return {
      type: GET_TAGS,
      cb,
    };
  }
  static getTagsSuccess(payload) {
    return {
      type: GET_TAGS_SUCCESS,
      payload,
    };
  }
  static getTagsFailure(payload) {
    return {
      type: GET_TAGS_FAILURE,
      payload,
    };
  }

  static getOnlineUsers(payload, cb) {
    return {
      type: GET_ONLINE_USERS,
      payload,
      cb,
    };
  }
  static getOnlineUsersSuccess(payload) {
    return {
      type: GET_ONLINE_USERS_SUCCESS,
      payload,
    };
  }
  static getOnlineUsersFailure(payload) {
    return {
      type: GET_ONLINE_USERS_FAILURE,
      payload,
    };
  }
  static getProgramTypes(cb) {
    return {
      type: GET_PROGRAM_TYPES,
      cb,
    };
  }
  static getProgramTypesSuccess(payload) {
    return {
      type: GET_PROGRAM_TYPES_SUCCESS,
      payload,
    };
  }
  static getProgramTypesFailure(payload) {
    return {
      type: GET_PROGRAM_TYPES_FAILURE,
      payload,
    };
  }
  static getPrograms(payload, cb) {
    return {
      type: GET_PROGRAMS,
      payload,
      cb,
    };
  }
  static getProgramsSuccess(payload) {
    return {
      type: GET_PROGRAMS_SUCCESS,
      payload,
    };
  }
  static getProgramsFailure(payload) {
    return {
      type: GET_PROGRAMS_FAILURE,
      payload,
    };
  }
  static getVisaInfo(cb) {
    return {
      type: GET_VISA_INFO,
      cb,
    };
  }
  static getVisaInfoSuccess(payload) {
    return {
      type: GET_VISA_INFO_SUCCESS,
      payload,
    };
  }
  static getVisaInfoFailure(payload) {
    return {
      type: GET_VISA_INFO_FAILURE,
      payload,
    };
  }
  static addVisaInfo(payload, cb) {
    return {
      type: ADD_VISA_INFO,
      payload,
      cb,
    };
  }
  static addVisaInfoSuccess(payload) {
    return {
      type: ADD_VISA_INFO_SUCCESS,
      payload,
    };
  }
  static addVisaInfoFailure(payload) {
    return {
      type: ADD_VISA_INFO_FAILURE,
      payload,
    };
  }
  static editVisaInfo(payload, cb) {
    return {
      type: EDIT_VISA_INFO,
      payload,
      cb,
    };
  }
  static editVisaInfoSuccess(payload) {
    return {
      type: EDIT_VISA_INFO_SUCCESS,
      payload,
    };
  }
  static editVisaInfoFailure(payload) {
    return {
      type: EDIT_VISA_INFO_FAILURE,
      payload,
    };
  }
  static deleteVisaInfo(payload, cb) {
    return {
      type: DELETE_VISA_INFO,
      payload,
      cb,
    };
  }
  static deleteVisaInfoSuccess(payload) {
    return {
      type: DELETE_VISA_INFO_SUCCESS,
      payload,
    };
  }
  static deleteVisaInfoFailure(payload) {
    return {
      type: DELETE_VISA_INFO_FAILURE,
      payload,
    };
  }
  static getPaymentPlans(cb) {
    return {
      type: GET_PAYMENT_PLANS,
      cb,
    };
  }
  static getPaymentPlansSuccess(payload) {
    return {
      type: GET_PAYMENT_PLANS_SUCCESS,
      payload,
    };
  }
  static getPaymentPlansFailure(payload) {
    return {
      type: GET_PAYMENT_PLANS_FAILURE,
      payload,
    };
  }
  static getDiffUniValues(cb) {
    return {
      type: GET_DIFF_UNI_VALUES,
      cb,
    };
  }
  static getDiffUniValuesSuccess(payload) {
    return {
      type: GET_DIFF_UNI_VALUES_SUCCESS,
      payload,
    };
  }
  static getDiffUniValuesFailure(payload) {
    return {
      type: GET_DIFF_UNI_VALUES_FAILURE,
      payload,
    };
  }
  static uploadImage(payload, cb) {
    return {
      type: UPLOAD_IMAGE,
      payload,
      cb,
    };
  }
  static uploadImageSuccess(payload) {
    return {
      type: UPLOAD_IMAGE_SUCCESS,
      payload,
    };
  }
  static uploadImageFailure(payload) {
    return {
      type: UPLOAD_IMAGE_FAILURE,
      payload,
    };
  }
  static uploadFile(payload, cb) {
    return {
      type: UPLOAD_FILE,
      payload,
      cb,
    };
  }
  static uploadFileSuccess(payload) {
    return {
      type: UPLOAD_FILE_SUCCESS,
      payload,
    };
  }
  static uploadFileFailure(payload) {
    return {
      type: UPLOAD_FILE_FAILURE,
      payload,
    };
  }
}
